// extracted by mini-css-extract-plugin
module.exports = {"successIcon":"styles__successIcon___2RIfM","loginFooter":"styles__loginFooter___1diiV"};